import { render } from "./ConfigurationsDataList.vue?vue&type=template&id=5ec9e751&ts=true"
import script from "./ConfigurationsDataList.vue?vue&type=script&lang=ts"
export * from "./ConfigurationsDataList.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__